import { Component, Inject, Input, OnInit } from '@angular/core';
import { CatalogosService } from '../../../../../expediente/services/catalogos.service';
import { WizardEventsService } from '../../../../services/wizard-events.service';
import { DatosSeccionWizardEventsService } from '../../../../services/datos-seccion-wizard-events.service';
import { ButtonControlService } from '../../../../services/button-control.service';
import { WIZARD_DATA } from '../../../../tokens/tokens';
import { PasoWizard } from '../../../../interface/wizard-informacion.types';

@Component({
  selector: 'lib-directorio-oficinas',
  templateUrl: './directorio-oficinas.component.html',
  styleUrls: ['./directorio-oficinas.component.css']
})
export class DirectorioOficinasComponent implements OnInit {

  directorio: any;
  clicked: any;

  constructor(
    @Inject(WIZARD_DATA) public data: any,
    public datosSeccionWizard: DatosSeccionWizardEventsService,
    private _catalogoService: CatalogosService
  ) {
    console.debug(data);
  }

  ngOnInit(): void {
    this._catalogoService.getByDiscriminator('OFICINA-ATENCION').subscribe(
      (response) => {
        this.directorio = response;
      }
    )
  }

}
